import { IFCWithChildren } from '~/common/interfaces/i-fc-with-childrent';
import { Logo } from '~/common/components/Logo';
import { CircularGlow } from '~/common/components/CircularGlow';

import { StyContainer, StyLogoWrapper } from './styles';

export const PublicLayout: IFCWithChildren = ({ children }) => (
  <StyContainer>
    <StyLogoWrapper>
      <CircularGlow
        opacity={0.1}
        animationBreathingTime="10s"
        width="300px"
        height="300px"
      />
      <div
        style={{
          zIndex: 999999,
        }}
      >
        <Logo />
      </div>
    </StyLogoWrapper>
    {children}
  </StyContainer>
);
